import * as React from "react";
import { Window } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import "./attendError.component.scss";

type AttendErrorProps = {
    onClose: () => void
}

const AttendErrorTitle = () => {
    return (
        <div className={"attend-error-title"}>
            Unable to Attend
        </div>
    );
}

const AttendError = (props: AttendErrorProps) => {
    return (
        <Window title={<AttendErrorTitle />} className={"attend-error-window"} onClose={props.onClose}
            maximizeButton={() => null}
            minimizeButton={() => null}
            initialWidth={600}
            resizable={false}
            modal={true}>
            <div className={"content"}>
                We couldn't confirm your attendance. Please speak to the front desk.
            </div>
            <div className={"footer"}>
                <Button className="btn-ok" themeColor={"primary"} onClick={props.onClose}>OK</Button>
            </div>
        </Window>
    );
}

export default AttendError
